// extracted by mini-css-extract-plugin
export default {"videoPlayer":"style_videoPlayer__ej-bn"};